import { get, post } from './helper';

export async function downloadMemberStatisticsReport(id, params = {}) {
  const res = await get({
    url: `admin/reports/members/${id}/export`,
    data: params,
  });
  return res?.data || res;
}

export async function downloadMembersStatisticsReport(params = {}) {
  const res = await get({
    url: 'admin/reports/members/export',
    data: params,
  });
  return res?.data || res;
}

export async function downloadOrderMembersReport(id, params = {}) {
  const res = await get({
    url: `admin/reports/group_buyings/${id}/export_by_user`,
    data: params,
  });
  return res?.data || res;
}

export async function downloadOrderItemsReport(id, params = {}) {
  const res = await get({
    url: `admin/reports/group_buyings/${id}/export_by_item`,
    data: params,
  });
  return res?.data || res;
}

export async function downloadOrdersReport(id) {
  const res = await get({
    url: `admin/reports/group_buyings/${id}/export`,
  });
  return res?.data || res;
}

export async function downloadOrdersStatisticsReport(params = {}) {
  const res = await get({
    url: 'admin/reports/group_buyings/export',
    data: params,
  });
  return res?.data || res;
}

export async function createGroupBuyingAsyncExport(data = {}) {
  const res = await post({
    url: 'admin/reports/group_buyings/async_export',
    data,
  });
  return res;
}

export async function getAsyncExportTasks(params = {}) {
  const res = await get({
    url: 'admin/tasks',
    data: params,
  });
  return res?.data || res;
}

export async function downloadAsyncExportTaskFile(uuid) {
  const res = await get({
    url: `admin/tasks/${uuid}/download`,
  });
  return res?.data || res;
}

export async function getGroupBuyingReport(id, params = {}) {
  const res = await get({
    url: `admin/reports/group_buyings/${id}`,
    data: params,
  });
  return res;
}

export async function getGroupBuyingReportList(params) {
  const res = await get({
    url: 'admin/reports/group_buyings',
    data: params,
  });
  const { data, link: { pagination } = {} } = res;
  return data && pagination ? { data, pagination } : res;
}

export async function getMemberReportList(params) {
  const res = await get({
    url: 'admin/reports/members',
    data: params,
  });
  const { data, link: { pagination } = {} } = res;
  return data && pagination ? { data, pagination } : res;
}

export async function getMemberReport(id, params) {
  const res = await get({
    url: `admin/reports/members/${id}`,
    data: params,
  });
  return res;
}

export async function getTempReport(key) {
  const res = await get({
    url: `client/group_buyings/temp_report/${key}`,
  });
  return res?.data || res;
}

export default {
  getGroupBuyingReport,
  getGroupBuyingReportList,
  getMemberReport,
  getMemberReportList,
  getTempReport,
};
